import '../assets/NcTextArea-DHr9DPOJ.css';
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { A as AlertCircle } from "./AlertCircleOutline-DVzpKQVu.mjs";
import { C as Check } from "./Check-5i4xKnkl.mjs";
import { resolveComponent, createElementBlock, openBlock, normalizeClass, createElementVNode, createCommentVNode, mergeProps, toDisplayString, createBlock, createTextVNode } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcTextArea",
  components: {
    AlertCircle,
    Check
  },
  inheritAttrs: false,
  props: {
    /**
     * The value of the input field
     */
    modelValue: {
      type: String,
      required: true
    },
    /**
     * The input label, always provide one for accessibility purposes.
     * This will also be used as a placeholder unless the placeholder
     * prop is populated with a different string.
     */
    label: {
      type: String,
      default: void 0
    },
    /**
     * Pass in true if you want to use an external label. This is useful
     * if you need a label that looks different from the one provided by
     * this component
     */
    labelOutside: {
      type: Boolean,
      default: false
    },
    /**
     * The placeholder of the input. This defaults as the string that's
     * passed into the label prop. In order to remove the placeholder,
     * pass in an empty string.
     */
    placeholder: {
      type: String,
      default: void 0
    },
    /**
     * Toggles the success state of the component. Adds a checkmark icon.
     * this cannot be used together with canClear.
     */
    success: {
      type: Boolean,
      default: false
    },
    /**
     * Toggles the error state of the component. Adds an error icon.
     * this cannot be used together with canClear.
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Additional helper text message
     *
     * This will be displayed beneath the input field. In case the field is
     * also marked as having an error, the text will be displayed in red.
     */
    helperText: {
      type: String,
      default: ""
    },
    /**
     * Disable the input field
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Class to add to the input field.
     * Necessary to use NcInputField in the NcActionInput component.
     */
    inputClass: {
      type: [Object, String],
      default: ""
    },
    /**
     * The resize CSS property sets whether an element is resizable, and if
     * so, in which directions.
     */
    resize: {
      type: String,
      default: "both",
      validator: (value) => ["both", "vertical", "horizontal", "none"].includes(value)
    }
  },
  emits: [
    "update:modelValue"
  ],
  computed: {
    computedId() {
      return this.$attrs.id && this.$attrs.id !== "" ? this.$attrs.id : this.inputName;
    },
    inputName() {
      return "input" + createElementId();
    },
    hasPlaceholder() {
      return this.placeholder !== "" && this.placeholder !== void 0;
    },
    computedPlaceholder() {
      return this.hasPlaceholder ? this.placeholder : this.label;
    },
    isValidLabel() {
      const isValidLabel = this.label || this.labelOutside;
      if (!isValidLabel) {
        console.warn("You need to add a label to the NcInputField component. Either use the prop label or use an external one, as per the example in the documentation.");
      }
      return isValidLabel;
    },
    ariaDescribedby() {
      const ariaDescribedby = [];
      if (this.helperText.length > 0) {
        ariaDescribedby.push(`${this.inputName}-helper-text`);
      }
      if (this.$attrs["aria-describedby"]) {
        ariaDescribedby.push(this.$attrs["aria-describedby"]);
      }
      return ariaDescribedby.join(" ") || null;
    }
  },
  methods: {
    /**
     * Focus the input element
     *
     * @public
     */
    focus() {
      this.$refs.input.focus();
    },
    /**
     * Select all the text in the input
     *
     * @public
     */
    select() {
      this.$refs.input.select();
    },
    handleInput(event) {
      this.$emit("update:modelValue", event.target.value);
    }
  }
};
const _hoisted_1 = { class: "textarea__main-wrapper" };
const _hoisted_2 = ["id", "disabled", "placeholder", "aria-describedby", "value"];
const _hoisted_3 = ["for"];
const _hoisted_4 = ["id"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Check = resolveComponent("Check");
  const _component_AlertCircle = resolveComponent("AlertCircle");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["textarea", { "textarea--disabled": $props.disabled }])
  }, [
    createElementVNode("div", _hoisted_1, [
      createElementVNode("textarea", mergeProps(_ctx.$attrs, {
        id: $options.computedId,
        ref: "input",
        class: ["textarea__input", [
          $props.inputClass,
          {
            "textarea__input--label-outside": $props.labelOutside,
            "textarea__input--success": $props.success,
            "textarea__input--error": $props.error
          }
        ]],
        disabled: $props.disabled,
        placeholder: $options.computedPlaceholder,
        "aria-describedby": $options.ariaDescribedby,
        "aria-live": "polite",
        style: { resize: $props.resize },
        value: $props.modelValue,
        onInput: _cache[0] || (_cache[0] = (...args) => $options.handleInput && $options.handleInput(...args))
      }), null, 16, _hoisted_2),
      !$props.labelOutside && $options.isValidLabel ? (openBlock(), createElementBlock("label", {
        key: 0,
        class: "textarea__label",
        for: $options.computedId
      }, toDisplayString($props.label), 9, _hoisted_3)) : createCommentVNode("", true)
    ]),
    $props.helperText.length > 0 ? (openBlock(), createElementBlock("p", {
      key: 0,
      id: `${$options.inputName}-helper-text`,
      class: normalizeClass(["textarea__helper-text-message", {
        "textarea__helper-text-message--error": $props.error,
        "textarea__helper-text-message--success": $props.success
      }])
    }, [
      $props.success ? (openBlock(), createBlock(_component_Check, {
        key: 0,
        class: "textarea__helper-text-message__icon",
        size: 18
      })) : $props.error ? (openBlock(), createBlock(_component_AlertCircle, {
        key: 1,
        class: "textarea__helper-text-message__icon",
        size: 18
      })) : createCommentVNode("", true),
      createTextVNode(" " + toDisplayString($props.helperText), 1)
    ], 10, _hoisted_4)) : createCommentVNode("", true)
  ], 2);
}
const NcTextArea = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-cc8bbaa7"]]);
export {
  NcTextArea as N
};
//# sourceMappingURL=NcTextArea-DKHjCur8.mjs.map
